import React from 'react';
import './index.css';

interface AllocationTableLoadingProps {
  numCarts: number;
  numProducts: number;
}

const AllocationTableLoading: React.FC<AllocationTableLoadingProps> = ({ numCarts, numProducts }) => {
  return (
    <div className="allocation-table-loading">
      {/* Header row */}
      <div className="allocation-table-loading-header">
        <div className="allocation-table-loading-product-header skeleton skeleton-color"></div>
        {Array.from({ length: numCarts }).map((_, index) => (
          <div key={index} className="allocation-table-loading-cart-header skeleton skeleton-color"></div>
        ))}
        <div className="allocation-table-loading-total-header skeleton skeleton-color"></div>
      </div>
      
      {/* Product rows */}
      {Array.from({ length: numProducts }).map((_, rowIndex) => (
        <div key={rowIndex} className="allocation-table-loading-row">
          <div className="allocation-table-loading-product-cell skeleton skeleton-color"></div>
          {Array.from({ length: numCarts }).map((_, colIndex) => (
            <div key={colIndex} className="allocation-table-loading-input-cell skeleton skeleton-color"></div>
          ))}
          <div className="allocation-table-loading-total-cell skeleton skeleton-color"></div>
        </div>
      ))}
      
      {/* Footer row */}
      <div className="allocation-table-loading-footer">
        <div className="allocation-table-loading-footer-label skeleton skeleton-color"></div>
        {Array.from({ length: numCarts }).map((_, index) => (
          <div key={index} className="allocation-table-loading-cart-total skeleton skeleton-color"></div>
        ))}
        <div className="allocation-table-loading-grand-total skeleton skeleton-color"></div>
      </div>
    </div>
  );
};

export default AllocationTableLoading;